import { analysisFields } from './analysis'

const workFields = `
      id
      slug
      title
      tags{
        label
      }
      libretto
      genreId
      description: descriptionFr
      descriptionEn
      dedicatee
      opus
      cycle
      revisions
      rim
      multimedias
      commanditary
      program
      programAuthor
      electronic
      electronicDevice
      studioInformation
      creations {
        date
        ensemble
        location
        dateAccuracy {
          year
          month
          day
        }
      }
      staffSlug
      staff {
        solo
        soloFr
        others
        othersFr
      }
      observation
      style
      styleEn
      styleSlug
      duration
      durationMax
      publisherDate
      publishingStartDate
      publishingEndDate
      editor
      medias {
        id
        slug
        title
        description
        duration
        type
        timestamp
        isExtract
files {
     getUrl
      originalFileName
    }
      }
      composers{
        firstName
        lastName
        slug
        birthDate
        deathDate
      }
      files{
        id,
        url
        getUrl
        mimeType
        originalFileName
      }
      suggestions {
        id,
        __typename
        cardTitle,
        cardDescription
        cardImage{
          alt
          url,
          centered
        }
        ... on Work {
          tags{
            label
          }
        }
        ... on Audio {
          tags{
            label
          }
        }
        ... on Video {
          tags{
            label
          }
        }

      }
      simili {
        id,
        __typename
        cardTitle,
        cardDescription
        cardImage{
          alt
          url,
          centered
        }
        ... on Work {
          tags{
            label
          }
        }
        ... on Audio {
          tags{
            label
          }
        }
        ... on Video {
          tags{
            label
          }
        }

      }
      parts
orderField
`
export const getWorkBySlug = () => {
  return `query getWorkBySlug($slug: String!) {
    workBySlug(slug: $slug) {
      ${workFields}
      titleFr
      documents{
        id,
        slug,
        title,
        titleFr,
        titleEn
        publishingStartDate
      }
      analyses {
        ${analysisFields}
      }
      sidneyVersions {
        id
        name
        title
        subtitle
        slug
      }
          }
  }`
}

export const getWorkByOldId = () => {
  return `query getWorkByOldId($oldId: String!) {
    workByOldId(oldId: $oldId) {
      ${workFields}
      documents{
        id,
        slug,
        title,
        titleFr,
        titleEn
        publishingStartDate
      }
      analyses {
        ${analysisFields}
      }
      sidneyVersions {
        id
        name
        title
        subtitle
        slug
      }
          }
  }`
}

export const worksWithoutVersions = () => {
  return `query worksWithoutVersions {
    worksWithoutVersions {
      ${workFields}
          }
    versionStats {
      current
      total
    }
  }`
}

const workByFields = `
      title
      titleFr
      slug
        composers {
          firstName
          lastName
        }
      orderField
`
export const worksByGenre = () => {
  return `query worksByGenre($slug: String!) {
    worksByGenre(slug: $slug) {
      title
      titleEn
      worksGroupBy {
      label
      works {
        ${workByFields}
            }
          }
    }
  }`
}

export const worksByCompositionYear = () => {
  return `query worksByCompositionYear($year: String!) {
    worksByCompositionYear(year: $year) {
      label
      works {
        ${workByFields}
      }
    }
  }`
}
export const worksByCreationYear = () => {
  return `query worksByCreationYear($year: String!) {
    worksByCreationYear(year: $year) {
      label
      works {
        ${workByFields}
      }
    }
  }`
}

export const workMinMaxLength = () => {
  return `query workMinMaxLength {
    workMinMaxLength{
     min,
     max
    }
  }`
}

export const workMinMaxDate = () => {
  return `query workMinMaxDate {
    workMinMaxDate{
      compositionDate{
        min,
        max
      }
     creationDate{
        min,
        max
      }
    }
  }`
}

export const getStaffSearch = () => {
  return `query staffSearch($genre: String, $electronic: Boolean, $withInstruments: String, $withoutInstruments: String) {
    staffSearchData {
    genres {
      id
      name
      nameFr
      nameEn
      slug
    }
    thesauri {
      id
      name
      nameFr
      nameEn
      slug
    }
    }
    staffSearch(genre: $genre, electronic: $electronic, withInstruments: $withInstruments, withoutInstruments: $withoutInstruments) {
      ${workFields}
    }
  }
  `
}

export const worksByKey = () => {
  return `query worksByKey($key: String, $limit:Int, $offset:Int) {
  worksByKey(key: $key, limit: $limit, offset: $offset) {
    keys
    total
    works {
      ${workFields}
    }
  }
  }`
}
